// src/utils/supabaseClient.js
import { createClient } from '@supabase/supabase-js';
const supabaseUrl = 'https://dlxdsljebcjgvvqbudaq.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRseGRzbGplYmNqZ3Z2cWJ1ZGFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY3NjMwNzYsImV4cCI6MjA3MjMzOTA3Nn0.zqNmduyRjl1Y9o6A0kIpkakoQ1fxu8H7hRO0dnyE9qs';
export const supabase = createClient(supabaseUrl, supabaseKey);